import React from 'react';
import { Network, Leaf, Globe, Atom, FlaskConical, Users, Compass } from 'lucide-react';
import './KeyTenets.css';

const tenets = [
    {
        tag: "#01 CONNECT",
        title: "Networking Opportunities",
        description: "Unlock exceptional networking prospects by joining our community, connecting with like-minded individuals and experts from diverse fields to exchange ideas, collaborate on projects, and broaden your perspectives",
        Icon: Network
    },
    {
        tag: "#02 SUSTAIN",
        title: "Innovation for Sustainability",
        description: "Dedicated to innovation, our community utilizes cutting-edge science and technology to engineer sustainable solutions, envisioning a brighter and more sustainable future for everyone.",
        Icon: Leaf
    },
    {
        tag: "#03 OPEN SCIENCE",
        title: "Open Research Community",
        description: "Committed to building a culture of transparency and collaboration, we strive to lead open research in India, making significant contributions to the global scientific community",
        Icon: Globe
    },
    {
        tag: "#04 SYNERGY",
        title: "Synergy of Discipline",
        description: "We harness the synergies of chemistry, biology, and artificial intelligence to explore novel interdisciplinary solutions for complex challenges.",
        Icon: Atom
    },
    {
        tag: "#05 PROJECTS",
        title: "Open Research Projects",
        description: "Participate in impactful open research projects, transcending traditional boundaries, to enhance your skills and contribute to the collective advancement of science and technology",
        Icon: FlaskConical
    },
    {
        tag: "#06 COLLABORATE",
        title: "Benefits of Collaboration",
        description: "Engage in cross-disciplinary collaborations within our community, fostering an environment where diverse perspectives unite to address challenges comprehensively",
        Icon: Users
    }
];

const KeyTenets = () => {
    return (
        <section id="services" className="cb-tenets-section">
            <div className="container">
                <div className="cb-section-title-wrap">
                    <div className="cb-studio-tag">[ 02 // RESEARCH PILLARS ]</div>
                    <h2 className="cb-section-title">
                        Key Tenets of Our Community
                    </h2>
                </div>

                <div className="cb-tenets-grid">
                    {tenets.map((tenet, idx) => {
                        const IconComponent = tenet.Icon;
                        return (
                            <div key={idx} className="cb-tenet-card">
                                <div className="cb-tenet-header-row">
                                    <div className="cb-tenet-icon-box">
                                        <IconComponent size={24} strokeWidth={1.8} />
                                    </div>
                                    <span className="cb-tenet-tag">{tenet.tag}</span>
                                </div>
                                <h3 className="cb-tenet-title">{tenet.title}</h3>
                                <p className="cb-tenet-desc">{tenet.description}</p>
                            </div>
                        );
                    })}
                </div>

                <div className="cb-tenet-wide-card">
                    <div className="cb-tenet-wide-icon-box">
                        <Compass size={32} strokeWidth={1.75} />
                    </div>
                    <div className="cb-tenet-wide-text">
                        <div className="cb-tenet-wide-meta">
                            <span className="cb-wide-kicker">#07 APEX HORIZON</span>
                        </div>
                        <h4>Empowering the Future</h4>
                        <p>
                            Shape the future through your research, ideas, and collaborations, joining us in making a lasting impact on the world
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default KeyTenets;